const script = document.currentScript;

const src = script.getAttribute('src');
const ssl = src.includes('https')
  ? 'https:'
  : src.includes('http')
  ? 'http:'
  : ''; // IanT in PR: I’d strongly recommend using the URL class instead of hand-parsing URLs. https://developer.mozilla.org/en-US/docs/Web/API/URL
const baseUrl = src.split('/')[2]; // assume other files are stored on same server
const components = script.getAttribute('components').split(' '); // lowercase with dashes, list separated by spaces
const mapName = script.getAttribute('map-name');
const mapSubName = script.getAttribute('map-sub-name');

const createAndAppendElement = (tagName, attributes, parentEl) => {
  const el = document.createElement(tagName);

  Object.entries(attributes).forEach(([name, value]) => {
    el.setAttribute(name, value);
  });

  parentEl.appendChild(el);
};

const insertAfter = (referenceNode, newNode) => {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};

const addCss = href => {
  createAndAppendElement('link', {rel: 'stylesheet', href}, document.head);
};

// add JS
createAndAppendElement(
  'script',
  {type: 'text/javascript', src: `${ssl}//${baseUrl}/js/config.js`},
  document.body
);

components.forEach(component => {
  createAndAppendElement(
    'script',
    {
      type: 'text/javascript',
      src: `${ssl}//${baseUrl}/js/${component}.js`,
    },
    document.body
  );
});

// add HTML
const embedEl = document.createElement('cem-embed');

// pass in customer/map name
embedEl.setAttribute('map-name', mapName);
// pass in site/map sub name
if (mapSubName) embedEl.setAttribute('map-sub-name', mapSubName);

embedEl.setAttribute('components', components.join(' '));

insertAfter(document.currentScript, embedEl);

// add CSS
addCss('https://api.tiles.mapbox.com/mapbox-gl-js/v1.12.0/mapbox-gl.css');
addCss(
  'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900'
);
addCss(
  'https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css'
);

components.forEach(component => {
  addCss(`${ssl}//${baseUrl}/css/${component}.css`);
});
